var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bidders-list tab-table"},[_c('settlement-table',{attrs:{"hide-actions":_vm.hideActions,"accounting-system-params":{sale_no: _vm.sale.sale_no},"exclude-search-fields":['sale_no'],"enable-frontend-export":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }